export default __webpack_public_path__ + "static/media/IconDesc_PlutoniumFuelRod.256.b0ae3c87.png";